import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import DialogTitle from '@material-ui/core/DialogTitle';

import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';


import { patchProject } from '../../modules/project';

import { closeDialog } from '../../modules/dialogs';

import { getUIText } from '../../utils/index';

class ProjectDetails extends React.Component {

  constructor(props) {
    super(props);
    const {
      project
    } = this.props;

    this.state = {
      title: project.title,
      clientName: project.clientName,
      reference: project.reference,
      address: project.address,
      notes: project.notes,
    };
  }

  onApply = () => {
    if(this.props.onCloseProjectDetails) {
      this.props.patchProject({...this.state});
      this.props.onCloseProjectDetails();
    }
    // TODO: validating?! do we need it?
  }

  render() {
    const {
      onCloseProjectDetails,
      translations,
      app,
      open
    } = this.props;

    const translationsProjectName = getUIText('PROJECTS-PROJECT_NAME', app.language, translations);
    const translationsProjectCustomer = getUIText('PROJECTS-CUSTOMER', app.language, translations);
    const translationsProjectReference = getUIText('PROJECTS-REFERENCE', app.language, translations);
    const translationsProjectAddress = getUIText('PROJECTS-ADDRESS', app.language, translations);
    const translationsProjectNotes = getUIText('PROJECTS-NOTES', app.language, translations);

    return (
      <Dialog className="project-dropdown-dialog" open={open} onClose={onCloseProjectDetails} >
        <DialogTitle>{getUIText('DIALOG_PROJECT_DETAILS_TITLE', app.language, translations)}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel className="label" htmlFor="name-simple" shrink>{translationsProjectName}</InputLabel>
                <Input className="input-item" value={this.state.title} inputProps={{placeholder: translationsProjectName}} onChange={(e) => {this.setState({'title': e.currentTarget.value});}} />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel className="label" htmlFor="name-simple" shrink>{translationsProjectCustomer}</InputLabel>
                <Input className="input-item" inputProps={{placeholder: translationsProjectCustomer}} value={this.state.clientName} onChange={(e) => {this.setState({'clientName': e.currentTarget.value});}}/>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel className="label" htmlFor="name-simple" shrink>{translationsProjectReference}</InputLabel>
                <Input className="input-item" inputProps={{placeholder: translationsProjectReference}} value={this.state.reference} onChange={(e) => {this.setState({'reference': e.currentTarget.value});}}/>
              </FormControl>
            </Grid>

            <Grid item xs={12} >
              <FormControl fullWidth>
                <InputLabel className="label" htmlFor="name-simple" shrink>{translationsProjectAddress}</InputLabel>
                <Input className="input-item" inputProps={{placeholder: translationsProjectAddress}} value={this.state.address} onChange={(e) => {this.setState({'address': e.currentTarget.value});}}/>
              </FormControl>
            </Grid>
            <Grid item xs={12} >
              <FormControl fullWidth>
                <InputLabel className="label" htmlFor="name-simple" shrink>{translationsProjectNotes}</InputLabel>
                <Input className="input-item" multiline inputProps={{placeholder: translationsProjectNotes}} value={this.state.notes} onChange={(e) => {this.setState({'notes': e.currentTarget.value});}}/>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={onCloseProjectDetails}>
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          <Button color="primary" autoFocus onClick={this.onApply.bind(this)}>
            {getUIText('GENERAL-APPLY', app.language, translations)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ProjectDetails.propTypes = {
    app: PropTypes.object,
    project: PropTypes.object,
    translations: PropTypes.object,
  onCloseProjectDetails: PropTypes.any,
  patchProject: PropTypes.any,
  open: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      app: state.app,
      translations: state.translations,
      project: state.project,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCloseProjectDetails: () => dispatch(closeDialog()),
      patchProject: (data) => {dispatch(patchProject(data));}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProjectDetails);
